import { takeLatest } from 'redux-saga/effects';
import { CONTACT_REQUEST_START, CONTACT_US_START } from 'redux/actions/types';
import { contactRequest } from './contact-saga';
import { contactUsSaga } from './contact-us-saga';

export default function* contactSagas() {
  yield takeLatest(CONTACT_REQUEST_START, contactRequest);
  yield takeLatest(CONTACT_US_START, contactUsSaga);
}
